const PRODUCT_LIST = [
  { id: 0, name: "전체선택" },
  { id: 1, name: "CT-P01 Case-Booster 01 탐정들의 조커" },
  { id: 2, name: "CT-P02 Case-Booster 02 동과 서의 대결전" },
  { id: 3, name: "CT-D06 Case-ThemeDeck 01 핫토리 헤이지 VS 괴도 키드" },
  { id: 4, name: "CT-D01 Case-StartDeck 01 에도가와 코난" },
  { id: 5, name: "CT-D02 Case-StartDeck 02 핫토리 헤이지" },
  { id: 6, name: "CT-D03 Case-StartDeck 03 괴도 키드" },
  { id: 7, name: "CT-D04 Case-StartDeck 04 아카이 슈이치" },
  { id: 8, name: "CT-D05 Case-StartDeck 05 아무로 토오루" },
  { id: 9, name: "프로모 카드" },
];

const COLOR_LIST = [
  { id: 0, name: "적" },
  { id: 1, name: "황" },
  { id: 2, name: "녹" },
  { id: 3, name: "청" },
  { id: 4, name: "백" },
  { id: 5, name: "흑" },
];

const CATEGORY_LIST = [
  { id: 6, name: "사건" },
  { id: 7, name: "이벤트" },
  { id: 8, name: "캐릭터" },
  { id: 9, name: "파트너" },
];

const RARITY_LIST = [
  { id: 10, name: "C" },
  { id: 11, name: "R" },
  { id: 12, name: "SR" },
  { id: 13, name: "D" },
  { id: 14, name: "PR" },
];

export { PRODUCT_LIST, COLOR_LIST, CATEGORY_LIST, RARITY_LIST };
